import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "form-text"
}
const _hoisted_6 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_7 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_8 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 0,
  class: "fw-semibold me-1"
}
const _hoisted_12 = {
  key: 1,
  class: "badge bg-secondary ms-1",
  title: "Wird als geplanter Termin kopiert"
}
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["id", "value"]
const _hoisted_16 = ["for"]
const _hoisted_17 = {
  key: 2,
  class: "badge bg-secondary ms-1",
  title: "Wird als geplanter Termin kopiert"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}

import { computed, ref, watch } from "vue";
import VueMultiselect from "vue-multiselect";
import BaseModal from "../../../../room-booking-management/calendar/components/BaseModal.vue";
import {
	fetchSemesters,
	fetchCourses,
	fetchSourceAppointments,
	copyAppointments,
} from "../api";


export default {
  __name: 'AppointmentCopyModal',
  props: {
	show: { type: Boolean, default: false },
	apiUrl: { type: String, required: true },
},
  emits: ["close", "copied"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const step = ref(1);
const loading = ref(false);
const saving = ref(false);
const error = ref("");

const semesters = ref([]);
const courses = ref([]);
const selectedSemesterId = ref(null);
const selectedCourseId = ref(null);

const sourceSeries = ref([]);
const sourceAppointments = ref([]);
const selectedSeries = ref([]);
const selectedAppointments = ref([]);

// vue-multiselect binds to objects, so resolve the selected ids back to options.
const selectedSemester = computed(
	() => semesters.value.find((s) => s.id === selectedSemesterId.value) || null
);
const selectedCourse = computed(
	() => courses.value.find((c) => c.id === selectedCourseId.value) || null
);

const semesterLabel = (semester) => semester?.short ?? "";

function onSemesterSelect(semester) {
	selectedSemesterId.value = semester ? semester.id : null;
	onSemesterChange();
}

function onCourseSelect(course) {
	selectedCourseId.value = course ? course.id : null;
}

function reset() {
	step.value = 1;
	error.value = "";
	courses.value = [];
	selectedSemesterId.value = null;
	selectedCourseId.value = null;
	sourceSeries.value = [];
	sourceAppointments.value = [];
	selectedSeries.value = [];
	selectedAppointments.value = [];
}

async function loadSemesters() {
	loading.value = true;
	try {
		const result = await fetchSemesters(props.apiUrl);
		semesters.value = result.semesters || [];
	} catch (e) {
		error.value = e.message;
	} finally {
		loading.value = false;
	}
}

async function onSemesterChange() {
	selectedCourseId.value = null;
	courses.value = [];
	if (!selectedSemesterId.value) {
		return;
	}
	loading.value = true;
	error.value = "";
	try {
		const result = await fetchCourses(props.apiUrl, selectedSemesterId.value);
		courses.value = result.courses || [];
	} catch (e) {
		error.value = e.message;
	} finally {
		loading.value = false;
	}
}

async function goToStep2() {
	if (!selectedCourseId.value) {
		return;
	}
	loading.value = true;
	error.value = "";
	step.value = 2;
	try {
		const result = await fetchSourceAppointments(props.apiUrl, selectedCourseId.value);
		sourceSeries.value = result.series || [];
		sourceAppointments.value = result.appointments || [];
		selectedSeries.value = [];
		selectedAppointments.value = [];
	} catch (e) {
		error.value = e.message;
	} finally {
		loading.value = false;
	}
}

async function confirmCopy() {
	saving.value = true;
	error.value = "";
	try {
		await copyAppointments(props.apiUrl, {
			sourceCourseId: selectedCourseId.value,
			seriesIds: selectedSeries.value,
			appointmentIds: selectedAppointments.value,
		});
		emit("copied");
	} catch (e) {
		saving.value = false;
		error.value = e.message;
	}
}

watch(
	() => props.show,
	(isShowing) => {
		if (isShowing) {
			reset();
			loadSemesters();
		}
	}
);

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(BaseModal, {
    show: __props.show,
    title: step.value === 1 ? 'Terminkopie – Quelle wählen' : 'Terminkopie – Termine auswählen',
    size: "lg",
    "modal-id": "appointmentCopyModal",
    "is-loading": saving.value,
    onClose: _cache[4] || (_cache[4] = $event => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(error.value), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Step 1: choose semester + course "),
      (step.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "tk-semester",
                class: "form-label"
              }, "Semesterkatalog", -1 /* CACHED */)),
              _createVNode(_unref(VueMultiselect), {
                id: "tk-semester",
                "model-value": selectedSemester.value,
                options: semesters.value,
                "track-by": "id",
                label: "short",
                searchable: true,
                "show-labels": false,
                "allow-empty": true,
                disabled: loading.value,
                placeholder: "Semester auswählen",
                "select-label": "",
                "deselect-label": "",
                "custom-label": semesterLabel,
                "onUpdate:modelValue": onSemesterSelect
              }, {
                noResult: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" Kein Semester gefunden. ", -1 /* CACHED */)
                ]))]),
                noOptions: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Keine Semester vorhanden. ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["model-value", "options", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                for: "tk-course",
                class: "form-label"
              }, "Veranstaltung", -1 /* CACHED */)),
              _createVNode(_unref(VueMultiselect), {
                id: "tk-course",
                "model-value": selectedCourse.value,
                options: courses.value,
                "track-by": "id",
                label: "label",
                searchable: true,
                "show-labels": false,
                "allow-empty": true,
                disabled: loading.value || !selectedSemesterId.value || courses.value.length === 0,
                placeholder: selectedSemesterId.value ? 'Veranstaltung auswählen' : 'Zuerst Semester wählen',
                "select-label": "",
                "deselect-label": "",
                "onUpdate:modelValue": onCourseSelect
              }, {
                noResult: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Keine Veranstaltung gefunden. ", -1 /* CACHED */)
                ]))]),
                noOptions: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" Keine Veranstaltungen in diesem Semester. ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["model-value", "options", "disabled", "placeholder"]),
              (selectedSemesterId.value && !loading.value && courses.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Keine Veranstaltungen in diesem Semester. "))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createCommentVNode(" Step 2: choose appointments to copy "),
            _createElementVNode("div", null, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "fas fa-spinner fa-spin me-2" }, null, -1 /* CACHED */),
                    _createTextVNode("Lädt … ", -1 /* CACHED */)
                  ]))]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (sourceSeries.value.length === 0 && sourceAppointments.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Die gewählte Veranstaltung hat keine Termine. "))
                      : _createCommentVNode("v-if", true),
                    (sourceSeries.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _cache[13] || (_cache[13] = _createElementVNode("h6", { class: "mb-2" }, " Terminreihen ", -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceSeries.value, (series) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 's' + series.id,
                              class: "form-check"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                id: 'tk-series-' + series.id,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectedSeries).value = $event)),
                                class: "form-check-input",
                                type: "checkbox",
                                value: series.id
                              }, null, 8 /* PROPS */, _hoisted_9), [
                                [_vModelCheckbox, selectedSeries.value]
                              ]),
                              _createElementVNode("label", {
                                for: 'tk-series-' + series.id,
                                class: "form-check-label"
                              }, [
                                (series.number)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "#" + _toDisplayString(series.number), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("strong", null, _toDisplayString(series.scheduleText || 'Terminreihe'), 1 /* TEXT */),
                                (series.isBooked)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "gebucht"))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("span", _hoisted_13, [
                                  _createTextVNode(" · " + _toDisplayString(series.count) + " Termine · " + _toDisplayString(series.timeText) + " Uhr · " + _toDisplayString(series.roomLabel) + " ", 1 /* TEXT */),
                                  (series.employeeName)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" · " + _toDisplayString(series.employeeName), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                  (series.bookingType)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(" · " + _toDisplayString(series.bookingType), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ], 8 /* PROPS */, _hoisted_10)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (sourceAppointments.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[14] || (_cache[14] = _createElementVNode("h6", { class: "mb-2" }, " Einzeltermine ", -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceAppointments.value, (appointment) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'a' + appointment.id,
                              class: "form-check"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                id: 'tk-appointment-' + appointment.id,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((selectedAppointments).value = $event)),
                                class: "form-check-input",
                                type: "checkbox",
                                value: appointment.id
                              }, null, 8 /* PROPS */, _hoisted_15), [
                                [_vModelCheckbox, selectedAppointments.value]
                              ]),
                              _createElementVNode("label", {
                                for: 'tk-appointment-' + appointment.id,
                                class: "form-check-label"
                              }, [
                                _createTextVNode(_toDisplayString(appointment.dateText) + " · " + _toDisplayString(appointment.timeText) + " Uhr · " + _toDisplayString(appointment.roomLabel) + " ", 1 /* TEXT */),
                                (appointment.employeeName)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · " + _toDisplayString(appointment.employeeName), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true),
                                (appointment.bookingType)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(" · " + _toDisplayString(appointment.bookingType), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true),
                                (appointment.isBooked)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "gebucht"))
                                  : _createCommentVNode("v-if", true)
                              ], 8 /* PROPS */, _hoisted_16)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
            ])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: saving.value,
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
      }, " Abbrechen ", 8 /* PROPS */, _hoisted_18),
      (step.value === 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary",
            disabled: !selectedCourseId.value || loading.value,
            onClick: goToStep2
          }, " Weiter ", 8 /* PROPS */, _hoisted_19))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              disabled: saving.value,
              onClick: _cache[3] || (_cache[3] = $event => (step.value = 1))
            }, " Zurück ", 8 /* PROPS */, _hoisted_20),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: saving.value || (selectedSeries.value.length === 0 && selectedAppointments.value.length === 0),
              onClick: confirmCopy
            }, [
              (saving.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(selectedSeries.value.length + selectedAppointments.value.length) + " Termin(e) kopieren ", 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_21)
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show", "title", "is-loading"]))
}
}

}